export const LAS_RUN_CANCELLED = 'uf.location_analysis.run_cancelled';
export const LAS_RUN_COMPLETED = 'uf.location_analysis.run_completed';
export const LAS_RUN_STARTED = 'uf.location_analysis.run_started';
export const LAS_RUN_FAILED = 'uf.location_analysis.run_failed';
